import Layout from "../layout/main";
import HomeMerchant from "../components/home";
/**
 * HomeMerchantPage
 *
 * صفحه اصلی داشبورد پذیرنده.
 * رندر کامپوننت HomeMerchant داخل لایه اصلی Layout برای نمایش داشبورد و اطلاعات مربوط به پذیرنده.
 *
 * @returns JSX.Element
 */

const HomeMerchantPage = () => {
  return (
    <Layout>
      <HomeMerchant />
    </Layout>
  );
};

export default HomeMerchantPage;
